// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.spin-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* Центрируем элемент */
  color: white;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.swing {
  transform-origin: center;
  transform-box: fill-box;
  animation: spin 0.5s linear infinite;
}

@keyframes rotation {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(-1);
  }
}
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  width: 200px;
  border: 3px solid transparent;
  border-top-color: #A04668;
  border-radius: 50%;
  animation: spin 2s linear infinite;
  position: relative;
}
.spinner:before, .spinner:after {
  content: "";
  position: absolute;
  border: 3px solid transparent;
  border-radius: 50%;
}
.spinner:before {
  border-top-color: #254E70;
  top: -12px;
  left: -12px;
  right: -12px;
  bottom: -12px;
  animation: spin 3s linear infinite;
}
.spinner:after {
  border-top-color: #FFFBFE;
  top: 6px;
  left: 6px;
  right: 6px;
  bottom: 6px;
  animation: spin 4s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UI/Spin/spin.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA,EAAA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAEF;;AACA;EAEI,wBAAA;EACA,uBAAA;EACA,oCAAA;AACJ;;AACA;EACE;IACE,oBAAA;EAEF;EAAA;IACE,qBAAA;EAEF;AACF;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,kCAAA;EACA,kBAAA;AAAF;AAEE;EAEE,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AADJ;AAIE;EACE,yBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;AAFJ;AAKE;EACE,yBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kCAAA;AAHJ;;AAOA;EACE;IACE,uBAAA;EAJF;EAMA;IACE,yBAAA;EAJF;AACF","sourcesContent":[".spin-wrapper {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%); /* Центрируем элемент */\r\n  color: white;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap:10px;\r\n  align-items: center;\r\n}\r\n\r\n.swing {\r\n  \r\n    transform-origin: center;\r\n    transform-box: fill-box;\r\n    animation: spin 0.5s linear infinite;\r\n}\r\n@keyframes rotation {\r\n  0%{\r\n    transform: scaleX(1);\r\n  }\r\n  100%{\r\n    transform: scaleX(-1);\r\n  }\r\n}\r\n\r\n\r\n.spinner {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 200px;\r\n  width: 200px;\r\n  border: 3px solid transparent;\r\n  border-top-color: #A04668;\r\n  border-radius: 50%;\r\n  animation: spin 2s linear infinite;\r\n  position: relative;\r\n\r\n  &:before,\r\n  &:after {\r\n    content: '';\r\n    position: absolute;\r\n    border: 3px solid transparent;\r\n    border-radius: 50%;\r\n  }\r\n\r\n  &:before {\r\n    border-top-color: #254E70;\r\n    top: -12px;\r\n    left: -12px;\r\n    right: -12px;\r\n    bottom: -12px;\r\n    animation: spin 3s linear infinite;\r\n  }\r\n\r\n  &:after {\r\n    border-top-color: #FFFBFE;\r\n    top: 6px;\r\n    left: 6px;\r\n    right: 6px;\r\n    bottom: 6px;\r\n    animation: spin 4s linear infinite;\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
